import React, { useCallback, useEffect, useRef, useState } from "react";
import { Formik, Field, Form } from "formik";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    CombineInputGroup,
    Wrapper,
    ScrollableContent,
    ActionSection,
    ModalHeading,
    RupeeIcon,
    ModalSubHeading,
    SelectionCard,
    CardWrapper,
    Note,
} from "../Styles/InputStyles";
import { Select, MenuItem, FormControl } from "@mui/material";
import { toast } from "react-toastify";
import moment from "moment";
import { MdOutlineInfo } from "react-icons/md";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendar } from "react-icons/fa";
import AddDiscount from "./AddDiscount";
import axios from "axios";
import Config from "../../Config";
import { useMutation } from "react-query";
import { useSelector } from "react-redux";
import tw from "tailwind-styled-components";

const TermsAgreement = ({
    onClose,
    firstStepData,
    addTermLoading,
    addTermMutate,
    stepOneData,
    data,
    handlePrevButton,
    route,
    source
}) => {
    const user = useSelector((state) => state.UserReducer.user);
    const [showLongTermOptions, setShowLongTermOptions] = useState(false);
    const [showAddDiscount, setShowAddDiscount] = useState(false);
    const [openCalendar, setOpenCalendar] = useState(null);
    const [addDiscountData, setAddDiscountData] = useState(null);
    const [discountedRent, setDiscountedRent] = useState(0);
    const [showDiscountedRent, setShowDiscountedRent] = useState(false);

    const rent = data?.data?.data?.room?.rent;
    const security = data?.data?.data?.property?.security;
    const rawMinMoveInDate = firstStepData?.data?.minMoveInDate;
    const isOnlinePaymentEnabled = data?.data?.data?.property?.isOnlinePaymentEnabled;
    const canTakeBookingAmt = data?.data?.data?.property?.canTakeBookingAmt;
    const minMoveInDate = rawMinMoveInDate
        ? moment(rawMinMoveInDate, "DD-MM-YYYY").format("YYYY-MM-DD")
        : null;
    const today = moment().format("YYYY-MM-DD");
    const allowedRentalCycles = ["01", "15", "00"];

    const initialValues = {
        monthlyRent: rent,
        securityDeposit: security,
        //bookingAmount: 0,
        moveInDate: "",
        checkoutDate: "",
        rentalCycle: allowedRentalCycles.includes(data?.data?.data?.property?.rentalCycle)
            ? data?.data?.data?.property?.rentalCycle
            : "01",
        agreementPeriod: data?.data?.data?.property?.agreementPeriod,
        noticePeriod: data?.data?.data?.property?.noticePeriod,
        lockInPeriod: data?.data?.data?.property?.lockInPeriod,
        agreementStartDate: "",
        tenantId: firstStepData?.data?.tenantId,
        propId: firstStepData?.data?.propId,
        roomId: firstStepData?.data?.roomId,
        electricityReading: 0,
        entireFlatOccupied: stepOneData?.entireFlatOccupied,
        rentalType: 1,
        isBookingAdjust: 1,
    };
    const monthlyRentRef = useRef(rent);
    const rentalTypeOptions = [
        { label: "Monthly", value: 1 },
        { label: "Short Stay", value: 2 },
        { label: "Long Term", value: 3 },
    ];

    const longTermOptions = [
        { label: "Quarterly", value: 3 },
        { label: "Half-Yearly", value: 6 },
        { label: "Annual", value: 12 },
    ];

    const rentalCycleOptions = [
        { label: "1st to 1st", value: "01" },
        { label: "15th to 15th", value: "15" },
        { label: "Move-In Date", value: "00" },
    ];
    const calculateDiscountedRent = useCallback((monthlyRent, discountData) => {
        if (!discountData) return 0;

        const { discountType, discount } = discountData;
        let discountValue = 0;

        if (discountType === 1) {
            discountValue = Number(discount);
        } else {
            discountValue = (Number(monthlyRent) * Number(discount)) / 100;
        }

        return discountValue;
    }, []);
    const handleSubmit = (values) => {
        const monthlyRentRegex = values.rentalType === 2 ? /^\d{1,6}$/ : /^(?!0+$)\d{4,6}$/;
        const maxMonthlyRent = 1000000;
        const securityDepositRegex = /^\d{1,6}$/;
        const maxSecurityDeposit = 1000000;

        if (
            !values.moveInDate ||
            !values.rentalType ||
            (values.rentalType !== 2 && (!values.monthlyRent || !values.lockInPeriod || values.noticePeriod == null || !values.agreementPeriod || !values.rentalCycle))
            ||
            (values.rentalType === 2 && !values.checkoutDate)
        ) {
            toast.error("All Fields are required");
            return;
        }

        if (
            !monthlyRentRegex.test(values.monthlyRent) ||
            parseInt(values.monthlyRent) > maxMonthlyRent ||
            (values.rentalType === 2 && parseInt(values.monthlyRent) < 1)
        ) {
            toast.error(
                values.rentalType === 2
                    ? "Per day rent must be between 1 and 10,00,000 and contain only numbers"
                    : "Monthly rent must be between 1000 and 10,00,000 and contain only numbers"
            );
            return;
        }

        if (
            (values.securityDeposit &&
                !securityDepositRegex.test(values.securityDeposit)) ||
            parseInt(values.securityDeposit) > maxSecurityDeposit
        ) {
            toast.error(
                "Security deposit must be between 1 and 10,00,000 and contain only numbers"
            );
            return;
        }

        if (values.rentalType === 3 && ![3, 6, 12].includes(values.rentalType)) {
            toast.error("For long-term rental, you must select Quarterly, Half-Yearly, or Annual rental type.");
            return;
        }

        if (values.rentalType === 2) {
            const moveIn = moment(values.moveInDate);
            const checkOut = moment(values.checkoutDate);
            if (checkOut.isSameOrBefore(moveIn)) {
                toast.error("Check-out date must be after Check-in date.");
                return;
            }
        }
        if (values.bookingAmount && values.bookingAmount > 0) {
            if (values.isBookingAdjust === 1) {
                // Adjusted from Rent
                if (values.bookingAmount > values.monthlyRent) {
                    toast.error("Booking amount cannot exceed monthly rent when adjusted from rent");
                    return;
                }
            } else {
                // Adjusted from Security
                if (values.bookingAmount > values.securityDeposit) {
                    toast.error("Booking amount cannot exceed security deposit when adjusted from security");
                    return;
                }
            }
        }
        if (values.rentalType === Config.RENTAL_OPTIONS.SHORT_DURATION) {
            addTermMutate({
                dailyRent: values.monthlyRent,
                rentalType: Number(values.rentalType),
                moveInDate: values.moveInDate,
                moveOutDate: values.checkoutDate,
                tenantId: firstStepData?.data?.tenantId,
                propId: firstStepData?.data?.propId,
                roomId: firstStepData?.data?.roomId,
                entireFlatOccupied: values.entireFlatOccupied,
                securityDeposit: values.securityDeposit || 0,
                rentalCycle: 0,
                notifyTenant: 1,
                addFromBooking: source === "booking" ? 1 : 0
            }
            )
        } else {
            addTermMutate({
                monthlyRent: values.monthlyRent,
                securityDeposit: values.securityDeposit || 0,
                bookingAmount: values.bookingAmount || 0,
                rentalCycle: String(values.rentalCycle),
                agreementPeriod: values.agreementPeriod,
                noticePeriod: values.noticePeriod,
                lockInPeriod: values.lockInPeriod,
                moveInDate: values.moveInDate,
                agreementStartDate: values.moveInDate,
                tenantId: firstStepData?.data?.tenantId,
                propId: firstStepData?.data?.propId,
                roomId: firstStepData?.data?.roomId,
                electricityReading: values.electricityReading,
                entireFlatOccupied: values.entireFlatOccupied,
                rentalType: Number(values.rentalType),
                bookingAdjustType: values.isBookingAdjust,
                addFromBooking: source === "booking" ? 1 : 0
            }
            );
        }
    };

    const validationSchema = Yup.object().shape({
        rentalType: Yup.number()
            .required("Please select Rental Type")
            .oneOf([1, 2, 3, 6, 12], "Invalid rental type"),

        monthlyRent: Yup.number()
            .required("Rent is required")
            .test(
                'rent-validation',
                'Invalid rent amount',
                function (value) {
                    if (this.parent.rentalType === 2) {
                        return value >= 1 && value <= 1000000;
                    }
                    return value >= 1000 && value <= 1000000;
                }
            ),

        securityDeposit: Yup.number()
            .min(0, 'Security deposit cannot be negative')
            .max(1000000, 'Security deposit cannot exceed ₹10,00,000'),

        bookingAmount: Yup.number()
            .typeError("Booking amount must be a number")
            .min(1, "Booking amount must be greater than 0")
            .test(
                "booking-amount-validation",
                function (value) {
                    const { isBookingAdjust, monthlyRent, securityDeposit } = this.parent;

                    if (!value) return true;

                    if (isBookingAdjust === 1) {
                        // Adjusted from Rent
                        if (value > monthlyRent) {
                            return this.createError({
                                message: `Booking amount cannot exceed monthly rent of ₹${monthlyRent}`
                            });
                        }
                    } else {
                        // Adjusted from Security
                        if (securityDeposit && value > securityDeposit) {
                            return this.createError({
                                message: `Booking amount cannot exceed security deposit of ₹${securityDeposit}`
                            });
                        }
                        if (!securityDeposit || securityDeposit === 0) {
                            return this.createError({
                                message: "Cannot adjust from security when security deposit is 0"
                            });
                        }
                    }
                    return true;
                }
            ),

        moveInDate: Yup.date()
            .required("Move-in date is required"),

        checkoutDate: Yup.date()
            .test(
                'checkout-date-required',
                'Check-out date is required for short stays',
                function (value) {
                    return this.parent.rentalType !== 2 || Boolean(value);
                }
            )
            .test(
                'checkout-after-movein',
                'Check-out date must be after check-in date',
                function (value) {
                    if (this.parent.rentalType !== 2) return true;
                    return !value || !this.parent.moveInDate || moment(value).isAfter(this.parent.moveInDate);
                }
            ),

        rentalCycle: Yup.string()
            .test(
                'rental-cycle-required',
                'Rental cycle is required',
                function (value) {
                    return ![1, 3, 6, 12].includes(this.parent.rentalType) || Boolean(value);
                }
            )
            .test(
                'valid-rental-cycle',
                'Invalid rental cycle',
                function (value) {
                    return ![1, 3, 6, 12].includes(this.parent.rentalType) || ["01", "15", "00"].includes(value);
                }
            ),

        agreementPeriod: Yup.number()
            .test(
                'agreement-period-required',
                'Agreement period is required',
                function (value) {
                    return ![1, 3, 6, 12].includes(this.parent.rentalType) || Boolean(value);
                }
            )
            .test(
                'valid-agreement-period',
                'Agreement period must be between 1 and 60 months',
                function (value) {
                    return ![1, 3, 6, 12].includes(this.parent.rentalType) ||
                        (value >= 1 && value <= 60);
                }
            ),

        noticePeriod: Yup.number()
            .test(
                'notice-period-required',
                'Notice period is required',
                function (value) {
                    return (
                        ![1, 3, 6, 12].includes(this.parent.rentalType) ||
                        value !== undefined && value !== null
                    );
                }
            )
            .test(
                'valid-notice-period',
                'Notice period must be between 0 and 6 months',
                function (value) {
                    return ![1, 3, 6, 12].includes(this.parent.rentalType) ||
                        (value >= 0 && value <= 6);
                }
            )
            .test(
                'notice-period-integer',
                'Notice period must be a whole number',
                function (value) {
                    return ![1, 3, 6, 12].includes(this.parent.rentalType) ||
                        Number.isInteger(value);
                }
            ),

        lockInPeriod: Yup.number()
            .test(
                'lockin-period-required',
                'Lock-in period is required',
                function (value) {
                    return ![1, 3, 6, 12].includes(this.parent.rentalType) || Boolean(value);
                }
            )
            .test(
                'valid-lockin-period',
                'Lock-in period must be between 1 and 12 months',
                function (value) {
                    return ![1, 3, 6, 12].includes(this.parent.rentalType) ||
                        (value >= 1 && value <= 12);
                }
            )
            .test(
                'lockin-less-than-agreement',
                'Lock-in period cannot exceed agreement period',
                function (value) {
                    return ![1, 3, 6, 12].includes(this.parent.rentalType) ||
                        !value ||
                        !this.parent.agreementPeriod ||
                        value <= this.parent.agreementPeriod;
                }
            )
            .test(
                'lockin-period-integer',
                'Lock-in period must be a whole number',
                function (value) {
                    return ![1, 3, 6, 12].includes(this.parent.rentalType) ||
                        Number.isInteger(value);
                }
            )
    });

    //------- Add Discount -------
    const AddDiscountFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/discount/add`, values, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/json",
            },
        });
    };

    const onAddDiscountSuccess = (data, variables) => {
        if (data?.data?.isSuccess === true) {
            // toast.success(data?.data?.msg || "Success");
            setAddDiscountData(variables)
            setShowAddDiscount(false)
            setShowDiscountedRent(true)
            const newDiscountedRent = calculateDiscountedRent(monthlyRentRef.current, variables);
            setDiscountedRent(newDiscountedRent);
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onAddDiscountError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: addDiscountLoading, mutate: addDiscountMutate } =
        useMutation(AddDiscountFunction, {
            onSuccess: onAddDiscountSuccess,
            onError: onAddDiscountError,
        });

    useEffect(() => {
        if (addDiscountData && showDiscountedRent) {
            const newDiscountedRent = calculateDiscountedRent(monthlyRentRef.current, addDiscountData);
            setDiscountedRent(newDiscountedRent);
        }
    }, [addDiscountData, showDiscountedRent, calculateDiscountedRent]);
    //------- Remove Discount -------

    const RemoveDiscountFunction = async (payload) => {
        return await axios.post(`${Config.apiUrl}/discount/remove`, payload, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/json",
            },
        });
    };

    const onRemoveDiscountSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Discount removed successfully");
            setAddDiscountData(null);
            setShowDiscountedRent(false);
            setDiscountedRent(0);
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onRemoveDiscountError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: removeDiscountLoading, mutate: removeDiscountMutate } =
        useMutation(RemoveDiscountFunction, {
            onSuccess: onRemoveDiscountSuccess,
            onError: onRemoveDiscountError,
        });

    const handleDiscountClose = () => {
        setShowAddDiscount(false);

    };
    const handleRemoveDiscount = () => {
        const payload = {
            tenantId: firstStepData?.data?.tenantId,
        };
        removeDiscountMutate(payload);
    };

    const isSecurityOptionDisabled = (values) => {
        return !values.securityDeposit || values.securityDeposit === 0;
    };
    return (
        <Formik initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            validateOnBlur={true}
            validateOnChange={true}>
            {({ values, setFieldValue, errors, touched }) => {
                monthlyRentRef.current = values.monthlyRent;
                if (addDiscountData && showDiscountedRent) {
                    const newDiscountedRent = calculateDiscountedRent(values.monthlyRent, addDiscountData);
                    if (newDiscountedRent !== discountedRent) {
                        setDiscountedRent(newDiscountedRent);
                    }
                }
                return (
                    <><div
                        className={`${showAddDiscount ? "flex" : "hidden"} h-screen w-screen bg-black/30 backdrop-blur-sm fixed inset-0 transition-all duration-400 z-10 ease-in-out`} /><div
                            className={`${showAddDiscount ? "translate-x-0" : "translate-x-full"} fixed h-screen right-0 top-0 transition-all duration-300 ease-in-out bg-white flex items-start rounded-l-2xl overflow-hidden w-full  justify-start z-50`}
                        >
                            {showAddDiscount && (
                                <AddDiscount
                                    handleClose={handleDiscountClose}
                                    tenantId={firstStepData?.data?.tenantId}
                                    monthlyRent={values.monthlyRent}
                                    addDiscountLoading={addDiscountLoading}
                                    addDiscountMutate={addDiscountMutate}
                                />
                            )}
                        </div><Form>
                            <ModalSubHeading>{route === 'selectProperty' ? "Step 3" : "Step 2"}</ModalSubHeading>
                            <ModalHeading>Terms & Agreement</ModalHeading>
                            <ScrollableContent>
                                <Wrapper>
                                    <InputGroup>
                                        <Label>Rental Type *</Label>
                                        <CardWrapper>
                                            {rentalTypeOptions.map((mode) => (
                                                <SelectionCard
                                                    key={mode.value}
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setFieldValue("rentalType", mode.value);
                                                        setShowLongTermOptions(mode.value === 3);

                                                        if (mode.value === 2) {
                                                            setFieldValue("monthlyRent", 500);
                                                            setFieldValue("securityDeposit", 0);
                                                            //setFieldValue("bookingAmount", 0);
                                                            setFieldValue("rentalCycle", "00");
                                                            setFieldValue("agreementPeriod", 0);
                                                            setFieldValue("noticePeriod", 0);
                                                            setFieldValue("lockInPeriod", 0);
                                                        } else {
                                                            setFieldValue("monthlyRent", rent);
                                                            setFieldValue("securityDeposit", security);
                                                            setFieldValue("rentalCycle", allowedRentalCycles.includes(data?.data?.data?.property?.rentalCycle)
                                                                ? data?.data?.data?.property?.rentalCycle
                                                                : "01");
                                                            setFieldValue("agreementPeriod", data?.data?.data?.property?.agreementPeriod);
                                                            setFieldValue("noticePeriod", data?.data?.data?.property?.noticePeriod);
                                                            setFieldValue("lockInPeriod", data?.data?.data?.property?.lockInPeriod);
                                                            setFieldValue("checkoutDate", "");
                                                        }
                                                    }}
                                                    className={values.rentalType === mode.value
                                                        ? "bg-[#0078BD] text-white"
                                                        : "bg-gray-100 text-gray-600"}
                                                >
                                                    <span className="text-sm">{mode.label}</span>
                                                </SelectionCard>
                                            ))}
                                        </CardWrapper>
                                        {touched.rentalType && errors.rentalType && (
                                            <p className="text-rose-600 text-sm">
                                                {errors.rentalType}
                                            </p>
                                        )}
                                        {showLongTermOptions && (
                                            <CardWrapper className="mt-2">
                                                {longTermOptions.map((mode) => (
                                                    <SelectionCard
                                                        key={mode.value}
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setFieldValue("rentalType", mode.value);
                                                        }}
                                                        className={values.rentalType === mode.value
                                                            ? "bg-[#0078BD] text-white"
                                                            : "bg-gray-100 text-gray-600"}
                                                    >
                                                        <span className="text-sm">{mode.label}</span>
                                                    </SelectionCard>
                                                ))}
                                            </CardWrapper>
                                        )}
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="monthlyRent">
                                            {values.rentalType === 1
                                                ? "Monthly Rent *"
                                                : values.rentalType === 2
                                                    ? "Per Day Rent *"
                                                    : values.rentalType === 3
                                                        ? "Quarterly Rent *"
                                                        : values.rentalType === 6
                                                            ? "Half-Yearly Rent *"
                                                            : values.rentalType === 12
                                                                ? "Annual Rent *"
                                                                : "Rent *"}
                                        </Label>
                                        <FieldWrappers>
                                            <RupeeIcon />
                                            <Field
                                                type="number"
                                                name="monthlyRent"
                                                id="monthlyRent"
                                                autoComplete="off"
                                                required
                                                className="pl-6" />
                                        </FieldWrappers>
                                        {touched.monthlyRent && errors.monthlyRent && (
                                            <p className="text-rose-600 text-sm">
                                                {errors.monthlyRent}
                                            </p>
                                        )}
                                        {values.rentalType !== Config.RENTAL_OPTIONS.SHORT_DURATION && (
                                            <div className="flex">
                                                {showDiscountedRent && (
                                                    <div className="text-gray-800 mr-auto text-sm">
                                                        Discounted Rent: ₹{Number(values.monthlyRent) - discountedRent}
                                                    </div>
                                                )}
                                                <button
                                                    type="button"
                                                    className="text-blue-400 underline ml-auto text-sm"
                                                    onClick={() => {
                                                        if (showDiscountedRent) {
                                                            handleRemoveDiscount();
                                                        } else {
                                                            setShowAddDiscount(true);
                                                        }
                                                    }}
                                                >
                                                    {showDiscountedRent ? 'Remove Discount' : 'Add Discount'}
                                                </button>
                                            </div>
                                        )}
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="securityDeposit">Security Deposit </Label>
                                        <FieldWrappers>
                                            <RupeeIcon />
                                            <Field
                                                type="number"
                                                name="securityDeposit"
                                                id="securityDeposit"
                                                autoComplete="off"
                                                className="pl-6" />
                                        </FieldWrappers>
                                    </InputGroup>
                                    {isOnlinePaymentEnabled === 1 && values.rentalType !== Config.RENTAL_OPTIONS.SHORT_DURATION && canTakeBookingAmt === 1 &&
                                        <><InputGroup>
                                            <Label htmlFor="bookingAmount">Booking Amount </Label>
                                            <FieldWrappers>
                                                <RupeeIcon />
                                                <Field
                                                    type="number"
                                                    name="bookingAmount"
                                                    id="bookingAmount"
                                                    autoComplete="off"
                                                    className="pl-6" />
                                            </FieldWrappers>
                                            {touched.bookingAmount && errors.bookingAmount && (
                                                <p className="text-rose-600 text-sm">
                                                    {errors.bookingAmount}
                                                </p>
                                            )}
                                        </InputGroup>

                                            {values.bookingAmount && values.bookingAmount > 0 && (
                                                <InputGroup>
                                                    <PayrollContainer>
                                                        <Label>Booking adjust from</Label>

                                                        <div className="flex bg-gray-100 rounded-xl p-1 w-fit">
                                                            <button
                                                                type="button"
                                                                onClick={() => setFieldValue("isBookingAdjust", 1)}
                                                                className={`px-4 py-1.5 text-sm rounded-md hover:text-gray-900 transition-all ${values.isBookingAdjust === 1
                                                                    ? "bg-white shadow text-gray-900"
                                                                    : "text-gray-500"}`}
                                                            >
                                                                Rent
                                                            </button>

                                                            <button
                                                                type="button"
                                                                onClick={() => setFieldValue("isBookingAdjust", 0)}
                                                                disabled={isSecurityOptionDisabled(values)}
                                                                className={`px-4 py-1.5 text-sm rounded-md transition-all ${values.isBookingAdjust === 0
                                                                    ? "bg-white shadow text-gray-900"
                                                                    : "text-gray-500"
                                                                    } ${isSecurityOptionDisabled(values) ? "opacity-50 cursor-not-allowed" : "hover:text-gray-900"}`}
                                                                title={isSecurityOptionDisabled(values) ? "Security deposit is 0, cannot adjust from security" : ""}
                                                            >
                                                                Security
                                                            </button>
                                                        </div>
                                                    </PayrollContainer>
                                                </InputGroup>
                                            )}
                                        </>
                                    }

                                    <InputGroup>
                                        <Label htmlFor="moveInDate">
                                            {values.rentalType === Config.RENTAL_OPTIONS.SHORT_DURATION ? "Check-in Date *" : "Move-In Date *"}
                                        </Label>
                                        <FieldWrappers>
                                            <DatePicker
                                                selected={values.moveInDate ? moment(values.moveInDate, "YYYY-MM-DD").toDate() : null}
                                                onChange={(date) => {
                                                    setFieldValue("moveInDate", moment(date).format("YYYY-MM-DD"));
                                                    setOpenCalendar(null);
                                                }}
                                                onClickOutside={() => setOpenCalendar(null)}
                                                onSelect={() => setOpenCalendar(null)}
                                                open={openCalendar === 'moveIn'}
                                                onInputClick={() => {
                                                    setOpenCalendar(openCalendar === 'moveIn' ? null : 'moveIn');
                                                }}
                                                dateFormat="yyyy-MM-dd"
                                                className="cursor-pointer items-center"
                                                placeholderText="YYYY-MM-DD"
                                                showIcon
                                                icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                                                showPopperArrow={false}
                                                minDate={minMoveInDate ? new Date(minMoveInDate) : null}
                                                onFocus={(e) => e.target.blur()}
                                                wrapperClassName="w-full"
                                                name="moveInDate"
                                                id="moveInDate"
                                                autoComplete="off"
                                                portalId="root-portal"
                                                popperClassName="react-datepicker-popper" />
                                        </FieldWrappers>
                                        {touched.moveInDate && errors.moveInDate && (
                                            <p className="text-rose-600 text-sm">
                                                {errors.moveInDate}
                                            </p>
                                        )}
                                    </InputGroup>

                                    {values.rentalType === Config.RENTAL_OPTIONS.SHORT_DURATION && (
                                        <InputGroup>
                                            <Label htmlFor="checkoutDate">Check-out Date *</Label>
                                            <FieldWrappers>
                                                <DatePicker
                                                    selected={values.checkoutDate ? moment(values.checkoutDate, "YYYY-MM-DD").toDate() : null}
                                                    onChange={(date) => {
                                                        setFieldValue("checkoutDate", moment(date).format("YYYY-MM-DD"));
                                                        setOpenCalendar(null);
                                                    }}
                                                    onClickOutside={() => setOpenCalendar(null)}
                                                    onSelect={() => setOpenCalendar(null)}
                                                    open={openCalendar === 'checkout'}
                                                    onInputClick={() => {
                                                        setOpenCalendar(openCalendar === 'checkout' ? null : 'checkout');
                                                    }}
                                                    dateFormat="yyyy-MM-dd"
                                                    className="cursor-pointer items-center"
                                                    placeholderText="YYYY-MM-DD"
                                                    showIcon
                                                    icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                                                    showPopperArrow={false}
                                                    minDate={values.moveInDate ? moment(values.moveInDate).add(1, 'days').toDate() : null}
                                                    onFocus={(e) => e.target.blur()}
                                                    wrapperClassName="w-full"
                                                    name="checkoutDate"
                                                    id="checkoutDate"
                                                    autoComplete="off"
                                                    portalId="root-portal"
                                                    popperClassName="react-datepicker-popper" />
                                            </FieldWrappers>
                                            {touched.checkoutDate && errors.checkoutDate && (
                                                <p className="text-rose-600 text-sm">
                                                    {errors.checkoutDate}
                                                </p>
                                            )}
                                        </InputGroup>
                                    )}

                                    {values.rentalType !== 2 && (
                                        <InputGroup>
                                            <Label>Rental Cycle *</Label>
                                            <CardWrapper>
                                                {rentalCycleOptions.map((mode) => (
                                                    <SelectionCard
                                                        key={mode.value}
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setFieldValue("rentalCycle", mode.value, false);
                                                        }}
                                                        className={values.rentalCycle === mode.value
                                                            ? "bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 text-white px-4 lg:px-6"
                                                            : "bg-gray-100 text-gray-600 px-4 lg:px-6"}
                                                    >
                                                        <span className="text-sm">{mode.label}</span>
                                                    </SelectionCard>
                                                ))}
                                            </CardWrapper>
                                        </InputGroup>
                                    )}

                                    {values.rentalType !== 2 && (
                                        <Note className="-mt-1">
                                            <MdOutlineInfo className="mt-0.5 mr-1" />
                                            {values.rentalCycle === "01"
                                                ? "Rent due will be generated on the 1st of each month."
                                                : values.rentalCycle === "15"
                                                    ? "Rent due will be generated on the 15th of each month."
                                                    : "Rent due will be generated each month based on move-in date."}
                                        </Note>
                                    )}

                                    {values.rentalType !== 2 && (
                                        <CombineInputGroup>
                                            <InputGroup>
                                                <Label htmlFor="agreementPeriod">Agreement Period *</Label>
                                                <FieldWrappers>
                                                    <Field
                                                        type="number"
                                                        name="agreementPeriod"
                                                        id="agreementPeriod"
                                                        autoComplete="off"
                                                        className="ml-2"
                                                        required />
                                                </FieldWrappers>
                                                {touched.agreementPeriod && errors.agreementPeriod && (
                                                    <p className="text-rose-600 text-sm">
                                                        {errors.agreementPeriod}
                                                    </p>
                                                )}
                                            </InputGroup>
                                        </CombineInputGroup>
                                    )}

                                    {values.rentalType !== 2 && (
                                        <CombineInputGroup>
                                            <InputGroup>
                                                <Label htmlFor="noticePeriod">Notice Period * (0-6 months)</Label>
                                                <FieldWrappers className={`${touched.noticePeriod && errors.noticePeriod ? 'border-red-500 border' : ''}`}>
                                                    <Field
                                                        type="number"
                                                        name="noticePeriod"
                                                        id="noticePeriod"
                                                        autoComplete="off"
                                                        className="ml-2"
                                                        required
                                                        min="0"
                                                        max="6"
                                                        step="1"
                                                        placeholder="0-6" />
                                                </FieldWrappers>
                                                {/* {touched.noticePeriod && errors.noticePeriod && (
                                                    <p className="text-rose-600 text-sm">
                                                        {errors.noticePeriod}
                                                    </p>
                                                )} */}
                                            </InputGroup>
                                            <InputGroup>
                                                <Label htmlFor="lockInPeriod">Lock-In Period * (1-12 months)</Label>
                                                <FieldWrappers className={`${touched.lockInPeriod && errors.lockInPeriod ? 'border-red-500 border' : ''}`}>
                                                    <Field
                                                        type="number"
                                                        name="lockInPeriod"
                                                        id="lockInPeriod"
                                                        autoComplete="off"
                                                        className="ml-2"
                                                        required
                                                        min="1"
                                                        max="12"
                                                        step="1"
                                                        placeholder="1-12" />
                                                </FieldWrappers>
                                                {/* {touched.lockInPeriod && errors.lockInPeriod && (
                                                    <p className="text-rose-600 text-sm">
                                                        {errors.lockInPeriod}
                                                    </p>
                                                )} */}
                                            </InputGroup>
                                        </CombineInputGroup>
                                    )}
                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={handlePrevButton}>
                                    Back
                                </SideCancelBtn>
                                <SubmitBtn type="submit" disabled={addTermLoading}>
                                    {addTermLoading ? "Processing..." : "Next"}
                                </SubmitBtn>
                            </ActionSection>
                        </Form></>
                )
            }}
        </Formik>
    );
};
const PayrollContainer = tw.div`
  flex items-center justify-between
  border border-gray-200
  rounded-lg
  px-4 h-12
  bg-white
`;
export default TermsAgreement;